import { useI18n } from 'hooks/useI18n';
import {
  StyledHero,
  StyledHeroContainer,
  StyledHeroTitle
} from './StateOfHiringHero.styled';

const StateOfHiringHero: React.FC = () => {
  const { t } = useI18n('state-of-hiring');

  return (
    <StyledHero>
      <StyledHeroContainer>
        <StyledHeroTitle>
          <span>{t('state-of-hiring.hero.pre-title')}</span>
          {t('state-of-hiring.hero.title')}
        </StyledHeroTitle>
        <p>{t('state-of-hiring.hero.desc')}</p>
      </StyledHeroContainer>
    </StyledHero>
  );
};

export default StateOfHiringHero;
